export enum SidebarLinkTypes {
  dashboard = "dashboardPage.title",
  company = "companyPage.title",
  companyManagement = "companyManagementPage.title",
  employees = "employeesPage.title",
  groups = "groupsPage.groups.title",
  actionModules = "actionModulesPage.actionModules.title",
  serviceModules = "serviceModulesPage.serviceModules",
  wallet = "wallet.title",
  transactions = "wallet.transactions.transactions",
  walletTypes = "walletTypes.title",
  calendar = "serviceModulesPage.calendar",
  folderService = "serviceModulesPage.folderService",
  leaderboard = "serviceModulesPage.leaderboard",
  incentivation = "incentivationPage.title",
  checklistAnswer = "incentivationPage.checklistAnswer",
  dropdownAnswer = "incentivationPage.dropdownAnswer",
  analysisFiles = "invoicesPage.title",
  analysisFilesUpcomingBonusRewards = "analysisPage.upcomingBonusRewards.title",
  analysisFilesBoughtVouchers = "analysisPage.boughtVouchers.title",
  analysisFilesNewEmployees = "analysisPage.newEmployees.title",
  analysisFilesDirectPayout = "analysisPage.directPayout.title",
  analysisFilesCompanyPension = "analysisPage.companyPension.title",
  analysisFilesFullPayout = "analysisPage.fullPayout.title",
  invoices = "invoicesPage.title",
  documentManagement = "documentManagementPage.documentManagement.title",
  documentManagementCertificatesTrainings = "documentManagementPage.documentManagement.certificatesTrainings.title",
  superAdmin = "superAdminPage.title",
  superAdminAnalysisFilesUpcomingBonusRewards = "analysisPage.upcomingBonusRewards.title",
  superAdminAnalysisFilesBoughtVouchers = "analysisPage.boughtVouchers.title",
  superAdminAnalysisFilesNewEmployees = "analysisPage.newEmployees.title",
  superAdminAnalysisFilesDirectPayout = "analysisPage.directPayout.title",
  superAdminAnalysisFilesCompanyPension = "analysisPage.companyPension.title",
  superAdminInvoices = "invoicesPage.title",
  superAdminActionModules = "superAdminPage.actionModules",
  configuration = "configurationPage.title",
  permissions = "permissionsPage.title",
  inAppNotifications = "genericInAppNotificationsPage.title",
  appDesign = "configurationPage.appDesign.appDesign",
  auditLogs = "auditLogsPage.title",
}

export enum SidebarLinkPathTypes {
  dashboard = "dashboard",
  company = "company",
  companyManagement = "company-management",
  employees = "employees",
  groups = "groups",
  actionModules = "actionmodules",
  serviceModules = "servicemodules",
  calendar = "servicemodules/calendar",
  folderService = "servicemodules/folder",
  leaderboard = "servicemodules/leaderboard",
  wallet = "wallet",
  transactions = "wallet/transactions",
  walletTypes = "wallet/types",
  incentivation = "incentivation/taxfreebenefit",
  checklistAnswer = "incentivation/taxfreebenefit/checklistAnswer",
  dropdownAnswer = "incentivation/taxfreebenefit/dropdownAnswer",
  analysisFilesUpcomingBonusRewards = "analysisfiles/upcomingbonusrewards",
  analysisFilesBoughtVouchers = "analysisfiles/boughtvouchers",
  analysisFilesNewEmployees = "analysisfiles/newemployees",
  analysisFilesDirectPayout = "analysisfiles/directpayout",
  analysisFilesCompanyPension = "analysisfiles/companypension",
  analysisFilesFullPayout = "analysisfiles/fullpayout",
  invoices = "invoices",
  documentManagement = "documentManagement",
  documentManagementCertificatesTrainings = "documentManagement/certificatesTrainings",
  superAdmin = "superadminarea",
  superAdminAnalysisFilesUpcomingBonusRewards = "superadminarea/analysisfiles/upcomingbonusrewards",
  superAdminAnalysisFilesBoughtVouchers = "superadminarea/analysisfiles/boughtvouchers",
  superAdminAnalysisFilesNewEmployees = "superadminarea/analysisfiles/newemployees",
  superAdminAnalysisFilesDirectPayout = "superadminarea/analysisfiles/directpayout",
  superAdminAnalysisFilesCompanyPension = "superadminarea/analysisfiles/companypension",
  superAdminInvoices = "superadminarea/invoices",
  superAdminActionModules = "superadminarea/actionModules",
  permissions = "permissions",
  inAppNotifications = "notifications/inApp",
  appDesign = "configuration/app-design",
  auditLogs = "auditlogs",
}
